<script setup lang="ts">
import { TEMPLATES } from "~/utilities/articles"
import type { Article } from "~/types/article"

defineProps<{
  article: Article
}>()
</script>

<template>
  <UPreviewQuizArticle
    v-if="article.quiz"
    :title="article.title"
    :restricted="article.restricted"
  />
  <UPreviewSlidesArticle
    v-else-if="article.template === 'USlidesArticle'"
    :title="article.title"
    :restricted="article.restricted"
    :img="article.img"
  />
  <UPreviewMathArticle
    v-else-if="
      article.template === TEMPLATES.MATH_TASK ||
      article.template === TEMPLATES.MATH_TASK_WITH_IMAGE
    "
    :data="article"
  />
  <UPreviewVideoArticle
    v-else-if="article.video"
    :title="article.title"
    :length="article.video.metadata.duration"
    :img="article.img"
  />
  <UPreviewTextArticle
    v-else
    class="text-black"
    :title="article.title"
    :data="article"
  />
</template>
